import { API_SUCCESS_CODE } from "./constants";

/** 后端统一信封（与 Spring `ApiResponse` 对齐） */
export type ApiEnvelope<T> = {
  code: string;
  message: string;
  data: T;
};

export function isApiSuccessCode(code: string | undefined): boolean {
  return code === API_SUCCESS_CODE;
}
